var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" }
                },
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "", "text-xs-center": "" } },
                    [
                      _c("StepTitle", [_vm._v("Agregar Campos")]),
                      _c("v-divider"),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm6: "",
                                md6: "",
                                "offset-xs10": "",
                                "align-end": ""
                              }
                            },
                            [
                              _c("AgregarButton2", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.modoVer,
                                    expression: "!modoVer"
                                  }
                                ],
                                on: {
                                  click: function($event) {
                                    return _vm.handleAgregarClick()
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { md12: "" } },
                            [
                              _c(
                                "v-card",
                                [
                                  !_vm.modoEditar && !_vm.modoVer
                                    ? _c("MantenedorGrid", {
                                        attrs: {
                                          "grid-options": _vm.gridOptions
                                        }
                                      })
                                    : _vm._e(),
                                  _vm.modoEditar || _vm.modoVer
                                    ? _c("MantenedorGrid", {
                                        attrs: {
                                          "grid-options":
                                            _vm.gridOptionsEditarVer
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("Confirmation", {
        attrs: {
          show: _vm.mostrarConfirmacionEliminar,
          titulo: _vm.tituloConfirmacionEliminar,
          mensaje: _vm.$t("mensajes.crud.eliminar.mensaje", {
            entidad: "Campo de Datos"
          }),
          textoBtnSi: _vm.$t("mensajes.crud.eliminar.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.eliminar.btnCancelar")
        },
        on: { modalConfirmationEmit: _vm.handleCierreConfirmacionEliminar }
      }),
      _c("CrearCampoDatosModal", {
        attrs: {
          show: _vm.muestraModalCampo,
          lstTipoDato: _vm.lstTipoDato,
          campoSeleccionado: _vm.campoSeleccionado,
          modoEditar: _vm.modoEditarCampo
        },
        on: {
          cerrar: _vm.handleCierreModal,
          crear: _vm.handleCampoCrear,
          editar: _vm.handleCampoEditar
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }